import { Controller } from "@hotwired/stimulus"

// 判定に使う帯の上端(スクロール容器の上端から)。トップバー(64px)と目次の高さ分。節の scroll-mt-32(128px)と合わせる
export const BAND_TOP = 128

// いま下線を付ける節の id。sections は目次の順の { id, intersecting, top }(top はスクロール容器の上端からの位置)。
// 帯と交差している節のうち目次で先のもの。どれとも交差していなければ、帯より上で始まった最後の節(末尾の注記を読んでいるとき)、
// それも無ければ(ページ先頭)最初の節
export function activeSectionId(sections, bandTop = BAND_TOP) {
  if (sections.length === 0) return null
  const visible = sections.find((s) => s.intersecting)
  if (visible) return visible.id
  const above = sections.filter((s) => s.top < bandTop)
  return (above[above.length - 1] || sections[0]).id
}

// AIレポートの目次。スクロール容器(レイアウトの data-scroll-container)の中で、いま見えている節のリンクに下線を付ける
export default class extends Controller {
  static targets = ["link"]

  connect() {
    this.root = this.element.closest("[data-scroll-container]")
    this.sections = this.linkTargets.map((a) => document.getElementById(a.hash.slice(1))).filter(Boolean)
    this.intersecting = new Set()
    this.observer = new IntersectionObserver((entries) => {
      entries.forEach((e) => (e.isIntersecting ? this.intersecting.add(e.target.id) : this.intersecting.delete(e.target.id)))
      this.refresh()
    }, { root: this.root, rootMargin: `-${BAND_TOP}px 0px -60% 0px` })
    this.sections.forEach((s) => this.observer.observe(s))
    this.refresh()
  }

  disconnect() {
    this.observer?.disconnect()
  }

  refresh() {
    const rootTop = this.root ? this.root.getBoundingClientRect().top : 0
    const id = activeSectionId(this.sections.map((s) => ({ id: s.id, intersecting: this.intersecting.has(s.id), top: s.getBoundingClientRect().top - rootTop })))
    if (id) this.activate(id)
  }

  activate(id) {
    this.linkTargets.forEach((a) => {
      const active = a.hash === `#${id}`
      // 同じプロパティのクラス(border-transparent と border-primary など)の優先はビルド後の CSS の順に依るので、外す側も切り替える
      a.classList.toggle("border-primary", active)
      a.classList.toggle("border-transparent", !active)
      a.classList.toggle("text-base-content", active)
      a.classList.toggle("text-base-content/70", !active)
      a.classList.toggle("font-semibold", active)
      if (active) {
        a.setAttribute("aria-current", "location")
        this.revealHorizontally(a)
      } else {
        a.removeAttribute("aria-current")
      }
    })
  }

  // スマホでは目次が横スクロールなので、下線の付いた項目が見えるよう ul の scrollLeft だけ合わせる
  // (scrollIntoView は縦のスクロールも動かすので使わない)
  revealHorizontally(link) {
    const list = link.closest("ul")
    if (!list) return
    const listRect = list.getBoundingClientRect()
    const linkRect = link.getBoundingClientRect()
    const margin = 16
    if (linkRect.left < listRect.left) list.scrollLeft += linkRect.left - listRect.left - margin
    else if (linkRect.right > listRect.right) list.scrollLeft += linkRect.right - listRect.right + margin
  }
}
